import StorageHelper from './storageHelper';
import { StorageKeys } from '../enums/storageKeys';
import PlatformHelper from './PlatformHelper';

/**
 * Save preffered subtitles language to local storage.
 *
 * @export
 * @param {string} langCode
 */
export function saveSubsLanguagePreference(langCode: string): void {
  if (!langCode) {
    StorageHelper.remove(StorageKeys.SUBTITLES);
  } else {
    StorageHelper.add(StorageKeys.SUBTITLES, langCode);
  }
}

/**
 * Retrieve subtitles pereffered language from local storage.
 *
 * @export
 * @returns {string}
 */
export function getSubsLanguagePreference(): string {
  return StorageHelper.get(StorageKeys.SUBTITLES);
}

/**
 * If the document is in fullscreen mode, exit fullscreen mode. Otherwise enter fulscreen mode.
 *
 * @export
 * @param {HTMLElement} el
 * @returns
 */
export function toggleFullScreen(el: HTMLVideoElement): void {
  if (document.fullscreenElement) {
    const methods = ['exitFullscreen', 'webkitExitFullscreen', 'msExitFullscreen', 'mozCancelFullScreen'];

    for (const method of methods) {
      if (document[method]) {
        document[method]();
        break;
      }
    }

    return;
  }

  enterFullScreen(el);
}

/**
 * Enter fullscreen mode using browser's preffered method.
 *
 * @export
 * @param {HTMLElement} el
 */
export function enterFullScreen(el: HTMLVideoElement): void {
  const methods = [
    'requestFullscreen',
    'webkitEnterFullscreen',
    'webkitRequestFullscreen',
    'msRequestFullscreen',
    'mozRequestFullScreen',
  ];

  /*
   * For mobile request fullscreen via <video> element itself to enter native player mode.
   * For desktop enter fullscreen via parent container (typically <div>) so we preserve our player with all the benefits.
   */
  if (!PlatformHelper.isMobile) {
    el = el.parentElement as HTMLVideoElement;
  }

  for (const method of methods) {
    if (el[method]) {
      el[method]();
      break;
    }
  }
}
